// extracted by mini-css-extract-plugin
module.exports = {"BtnAddPart":"_7eUyNVeDDOdDb7flwp6MIw==","AddPartDropzone":"zbpHOxv3dGGZcIuwN3Tm6A==","PartDimensionsText":"M+aVgrJEtQFL2RKG00Y20g==","SupportedTypes":"s5YLKNnqnO6WtLa4SaY0TQ=="};